<ion-content [fullscreen]="true" class="soft-page">
  @if (analyticsTutorialMode) {
    @defer (on immediate) { <app-analytics-tutorial></app-analytics-tutorial> }
  } @else {

  <div class="content-wrapper">

    <div class="page-header">
      <h2 class="page-title">Statistiche</h2>
    </div>
    <mat-accordion class="soft-accordion">
      <mat-expansion-panel class="soft-panel" [expanded]="false" hideToggle>
        <mat-expansion-panel-header class="soft-header">
          <div class="filter-header-content">
            <div class="icon-box">
              <ion-icon name="filter"></ion-icon>
            </div>
            <span class="header-title">Filtri Visualizzazione</span>
            @if(hasActiveFilters) {
            <div class="active-badge">Attivi</div>
            }
          </div>
          <ion-icon name="chevron-down-outline" class="toggle-icon"></ion-icon>
        </mat-expansion-panel-header>

        <div class="filters-body">
          @if(isSuperUser) {
          <div class="soft-input-wrapper">
            <mat-form-field appearance="fill">
              <mat-label>Cliente</mat-label>
              <mat-select [(ngModel)]="currentContext.customerId" (selectionChange)="onContextChange('customer')"
                panelClass="soft-select-panel">
                <mat-option [value]="null">Tutti</mat-option>
                @for(c of customersList; track c.id) { <mat-option [value]="c.id">{{ c.businessName }}</mat-option> }
              </mat-select>
            </mat-form-field>
          </div>

          <div class="soft-input-wrapper">
            <mat-form-field appearance="fill">
              <mat-label>Organizzazione</mat-label>
              <mat-select [(ngModel)]="currentContext.organizationId"
                (selectionChange)="onContextChange('organization')" panelClass="soft-select-panel"
                [disabled]="!currentContext.customerId && isSuperUser">
                <mat-option [value]="null">Tutte</mat-option>
                @for(o of organizationsList; track o.id) { <mat-option [value]="o.id">{{ o.name }}</mat-option> }
              </mat-select>
            </mat-form-field>
          </div>
          }

          <div class="soft-input-wrapper">
            <mat-form-field appearance="fill">
              <mat-label>Edificio</mat-label>
              <mat-select [(ngModel)]="currentContext.buildingId" (selectionChange)="onContextChange('building')"
                panelClass="soft-select-panel" [disabled]="!currentContext.organizationId">
                <mat-option [value]="null">Tutti</mat-option>
                @for(b of buildingsList; track b.id) { <mat-option [value]="b.id">{{ b.name }}</mat-option> }
              </mat-select>
            </mat-form-field>
          </div>

          <div class="soft-input-wrapper">
            <mat-form-field appearance="fill">
              <mat-label>Unità</mat-label>
              <mat-select [(ngModel)]="currentContext.unitId" (selectionChange)="onContextChange('unit')"
                panelClass="soft-select-panel" [disabled]="!currentContext.buildingId">
                <mat-option [value]="null">Tutti</mat-option>
                @for(u of unitsList; track u.id) { <mat-option [value]="u.id">{{ u.name }}</mat-option> }
              </mat-select>
            </mat-form-field>
          </div>

          @if(hasActiveFilters) {
          <button class="soft-btn-reset" (click)="resetContext()">
            <ion-icon name="refresh-outline"></ion-icon>
            Resetta Filtri
          </button>
          }
        </div>
      </mat-expansion-panel>
    </mat-accordion>

    @if(isDataLoading || isContextLoading) {
    <mat-progress-bar mode="indeterminate" class="soft-progress"></mat-progress-bar>
    }

    <div class="kpi-grid">
      @for(widget of kpiWidgets; track widget.id) {
      <div class="soft-card kpi-card" [class.border-teal]="widget.section === 'sensors'"
        [class.border-red]="widget.section === 'alerts'">
        <div class="kpi-icon-bg">
          <ion-icon [name]="widget.icon"></ion-icon>
        </div>
        <div class="kpi-data">
          <span class="kpi-label">{{ widget.label }}</span>
          @if(widget.loading) {
          <ion-spinner name="dots" color="medium"></ion-spinner>
          } @else {
          @if(widget.widgetType === 'simple_on') {
          <span class="kpi-value">{{ widget.data ? widget.data.online : '—' }}<small>@if(widget.data) {/ {{widget.data.total}}}</small></span>
          } @else {
          <span class="kpi-value">{{ widget.data }}</span>
          }
          }
          @if(widget.id === 'kpi_sensors') {
            <button type="button" class="sensor-details-button" [attr.aria-expanded]="sensorsDetailsOpen" aria-controls="mobile-sensor-connectivity-details" (click)="sensorsDetailsOpen = !sensorsDetailsOpen">
              {{'CONNECTIVITY.DETAILS' | translate}}<ion-icon name="chevron-down-outline" [style.transform]="sensorsDetailsOpen ? 'rotate(180deg)' : null"></ion-icon>
            </button>
          }
        </div>
      </div>
      }
    </div>

    @if(sensorsDetailsOpen) {
      @defer (on immediate) {
        <app-sensor-connectivity panelId="mobile-sensor-connectivity-details" [customerId]="currentContext.customerId" [organizationId]="currentContext.organizationId"
          [buildingId]="currentContext.buildingId" [unitId]="currentContext.unitId" [showPeriodControl]="true" [expanded]="true" (expandedChange)="sensorsDetailsOpen = $event"></app-sensor-connectivity>
      }
    }

    <div class="charts-list">
      @for(widget of chartWidgets; track widget.id) {
      <div class="soft-card chart-card">

        <div class="chart-header">
          <span class="chart-title">{{ widget.label }}</span>

          @if(widget.availableFilters) {
          <button mat-icon-button [matMenuTriggerFor]="menu" class="chart-opt-btn">
            <ion-icon name="ellipsis-vertical"></ion-icon>
          </button>
          <mat-menu #menu="matMenu" class="soft-custom-menu">
            <div class="menu-label">PERIODO</div>
            @for(filter of widget.availableFilters; track filter) {
            <button mat-menu-item (click)="onFilterChange($any(widget), filter)">
              <span>{{ filterMap[filter] || filter }}</span>
              @if(widget.currentFilter === filter) { <ion-icon name="checkmark" color="primary"></ion-icon> }
            </button>
            }
          </mat-menu>
          }
        </div>

        <div class="chart-body">
          @if(widget.loading) {
          <div class="loading-state">
            <ion-spinner name="crescent"></ion-spinner>
          </div>
          } @else {
          @if(!widget.data || widget.data.length === 0) {
          <div class="empty-state">
            <ion-icon name="bar-chart-outline"></ion-icon>
            <span>No Data</span>
          </div>
          } @else {

          @switch(widget.widgetType) {
          @case('vertical_bars_chart') {
          <div class="chart-container">
            <ngx-charts-bar-vertical [scheme]="widget.chartScheme || 'cool'" [results]="widget.data" [gradient]="false"
              [xAxis]="true" [yAxis]="true" [showXAxisLabel]="false" [showYAxisLabel]="false" [barPadding]="10">
            </ngx-charts-bar-vertical>
          </div>
          }
          @case('pie_chart') {
          <div class="chart-container" echarts [options]="getEchartsPieOptions($any(widget))" [autoResize]="true"></div>
          }
          @case('sunburst') {
          <div class="chart-container" style="height: 350px;" echarts [options]="getSunburstOptions($any(widget))"
            [autoResize]="true"></div>
          }
          @case('advanced_pie_chart') {
          <div class="chart-container" style="height: 250px;">
            <ngx-charts-advanced-pie-chart [results]="widget.data" [gradient]="false"
              [animations]="true"></ngx-charts-advanced-pie-chart>
          </div>
          }
          }

          }
          }
        </div>
      </div>
      }
    </div>

    @if(isSuperUser) {
      @defer (on immediate) {
        <app-posture-statistics [buildingId]="currentContext.buildingId" [unitId]="currentContext.unitId"></app-posture-statistics>
      }
    }

    <div style="height: 50px;"></div>

  </div>
  }
</ion-content>
